const expandListener = expander => () => {

  //find sibling submenu
  const expanderSiblings = expander.parentElement.children;//('.menu__item__submenu');
  if (!expanderSiblings) {
    return;
  }

  const directSiblingSubmenus = Array.from(expanderSiblings).reduce((accumulator, currentValue) => {
    if (currentValue.classList.contains('menu__item__submenu')) {
      accumulator.push(currentValue);
      return accumulator;
    }
    return accumulator;
  }, []);

  expander.classList.toggle('--open');
  const expanderIsOpen = expander.classList.contains('--open');

  Array.from(directSiblingSubmenus).forEach(submenu => {

    Velocity(submenu, (expanderIsOpen ? 'slideDown' : 'slideUp')).then(() => {
      if (!expanderIsOpen) {
        //find all neice and nephew expanders and close them
        for (const nephewExpander of expander.parentElement.getElementsByClassName('menu__expander')) {
          nephewExpander.classList.remove('--open');
        }
        for (const nephewSubmenu of expander.parentElement.getElementsByClassName('menu__item__submenu')) {
          Velocity(nephewSubmenu, 'slideUp', {duration: 0});
        }
      }
    });
  });
};

const menuButtonListener = (menuButton, openingHours) => () => {

  if (openingHours) {
    openingHours.classList.remove('--visible');
  }
  menuButton.classList.toggle('--open');
  Array.from(menuButton.getElementsByClassName('header__top-menu__mobile-nav-icon__bar')).forEach(bar => {
    bar.classList.toggle('--open');
    return true;
  });

  const menu = document.getElementsByClassName('menu')[0];
  menu.classList.toggle('--open');
  Velocity(menu, menu.classList.contains('--open') ? 'slideDown' : 'slideUp').then(() => {

    if (!menu.classList.contains('--open')) {
      //remove --open from all expanders
      for (const expander of document.getElementsByClassName('menu__expander')) {
        expander.classList.remove('--open');
      }

      //slide all menus up
      for (const subMenu of document.getElementsByClassName('menu__item__submenu')) {
        Velocity(subMenu, 'slideUp', {duration: 0});
      }
    }
  });
};

export const initMenu = () => {
  //add listeners to expanders
  for (const expander of document.getElementsByClassName('menu__expander')) {
    expander.addEventListener('click', expandListener(expander));
  }
  const menuButton = document.getElementsByClassName('header__top-menu__mobile-nav-icon')[0];
  const openingHours = document.getElementsByClassName('opening-hours')[0];
  menuButton.addEventListener('click', menuButtonListener(menuButton, openingHours));
};
